export default [
  { text: '01', value: 1 },
  { text: '02', value: 2 },
  { text: '03', value: 3 },
  { text: '04', value: 4 },
  { text: '05', value: 5 },
  { text: '06', value: 6 },
  { text: '07', value: 7 },
  { text: '08', value: 8 },
  { text: '09', value: 9 },
  { text: '10', value: 10 },
  { text: '11', value: 11 },
  { text: '12', value: 12 }
]
